/**
 * Zod schemas for the entity DTOs. Source of truth = the backend response
 * contracts validated by the integration suite (tests/integration/src/schemas/).
 * Keep these in sync — when a backend response shape changes, both places
 * change together.
 */
import { z } from 'zod';

export const IsoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const idField = z.number().int().nullable().optional();
const nullableString = z.string().nullable().optional();

export const CountryDTO = z.object({
  id: idField,
  name: nullableString,
  region: nullableString,
}).passthrough();
export type Country = z.infer<typeof CountryDTO>;

export const LanguageDTO = z.object({
  id: idField,
  name: nullableString,
}).passthrough();
export type Language = z.infer<typeof LanguageDTO>;

export const LocationDTO = z.object({
  id: idField,
  name: nullableString,
  description: nullableString,
}).passthrough();
export type Location = z.infer<typeof LocationDTO>;

export const AccomodationPlaceDTO = z.object({
  id: idField,
  name: z.string(),
  comments: nullableString,
  address: nullableString,
  locationId: z.number().int().nullable().optional(),
  locationName: nullableString,
}).passthrough();
export type AccomodationPlace = z.infer<typeof AccomodationPlaceDTO>;

export const UserMiniDTO = z.object({
  id: z.number().int(),
  login: z.string().optional(),
  firstName: nullableString,
  lastName: nullableString,
  email: nullableString,
}).passthrough();
export type UserMini = z.infer<typeof UserMiniDTO>;

export const RoleDTO = z.object({
  id: idField,
  name: nullableString,
  users: z.array(UserMiniDTO).optional().default([]),
}).passthrough();
export type Role = z.infer<typeof RoleDTO>;

export const ReportMailDTO = z.object({
  id: idField,
  email: nullableString,
  report: nullableString,
  location: nullableString,
  period: z.number().int().nullable().optional(),
  hour: z.number().int().nullable().optional(),
  format: nullableString,
  extraParams: nullableString,
}).passthrough();
export type ReportMail = z.infer<typeof ReportMailDTO>;
